import { useEffect } from "react";
import ConsentSucessIcon from "../../assets/images/ConsentSucessIcon";
import { consentConstant } from "../../constants/constants";
import { useLocation, useNavigate } from "react-router-dom";


export const ConsentSucessComponent = () => {
 

  return (
    <div className="bg-primary h-dvh flex flex-col justify-center ">
      <div className="flex flex-col items-center">
        <div data-testid="FaceRecognitionIcon">
          <ConsentSucessIcon />
        </div>
        <div className="text-whiteColor consentHeaderText text-center pt-6">
          {consentConstant.submissionSucessTitle}
        </div>
        <div className="consentSucessDescription text-whiteColor text-center px-11 pt-9 ">
          {consentConstant.submissionSucessDescription}
        </div>
      </div>
    </div>
  );
};
